import React from 'react';
import './styles.css';
import Views from "./components/views";

const MenuItemUnits = () => {

  return (<Views/>);
};

export default MenuItemUnits;